<div class="maintenance-banner" *ngIf="isUpcomingMaintenance()">
    <p class="title">{{ getMaintenanceTitle() }}</p>
    <p>{{ getMaintenanceMessage() }}</p>
</div>
